import scrollLockGlobalStyles from 'components/Common/ScrollLock/scrollLockGlobalStyles'
import { createGlobalStyle } from 'styled-components'
import Reset from './base/reset'
import Typography from './base/typography'
import ReactModal from './reactModal'
import ThemeStyles from './themes/ThemeStyles'
import contentColoursStyle from './utils/contentColoursStyle'
import Appsflyer from './vendor/appsflyer/banner'
import Print from './vendor/bootstrap/Print'
import NukaCarouselRtl from './vendor/nuka-carousel/rtl'

import nestedButtonWarningStyle from './utils/nestedButtonWarningStyle'
import HeadlessModeStyles from './base/headlessMode'

const GlobalStyles = createGlobalStyle`
  ${ThemeStyles}
  ${Reset}
  ${Typography}
  ${Print}
  ${ReactModal}
  ${Appsflyer}
  ${NukaCarouselRtl}
  ${scrollLockGlobalStyles}
  ${contentColoursStyle}
  ${nestedButtonWarningStyle}
  ${HeadlessModeStyles}

  @media print {
    .no-print {
      display: none !important;
    }

    .print-no-break-page-inside {
      break-inside: avoid-page;
    }

    .print-no-break-page-after {
      break-after: avoid-page;
    }
  }
`

export default GlobalStyles
